<template>
  <Navbar />
  <div class="admin-layout">
    <SaidManuBar />

    <!-- sidenav -->

    <!--<div class="col-lg-2 col-md-3 col-sm-4 col-12 pl-0">-->
    <!-- </div> -->

    <!-- <div class="col-lg-10 col-md-9 col-sm-8 col-12 p-1 bg-white bg-gradient periodhistory-content">-->
    <div class="main-content-wrapper main-content-table Period_History">
      <div class="period_history_table">

        <h3 class="periodhistory-title p-1 mr-0 m-1 ml-0 add-bg-color-sub-header" stylr=" text-transform: capitalize;">
          Red Envelope
        </h3>
        <nav class="navbar pr-0 pl-0">
          <div>
            <button class="btn btn-envelop" @click="addRedEnvelop" style="margin-right: 10px;">
              Envelope User
            </button>
          </div>
          <div class="periodhistory-search-box d-flex ml-auto" role="search">
            <label>Search:</label>
            <input class="form-control p-1" v-model="searchTerms" @input="search()" type="search" aria-label="Search"
              id="input" />
          </div>
        </nav>
        <div class="table-responsive table-responsive-sm">
          <table class="periodhistory-table table" v-if="loader === false">
            <thead>
              <tr>
                <th scope="col" class="font-weight-bold text-center">
                  #
                </th>
                <th scope="col" class="font-weight-bold text-center">
                  Name
                </th>
                <th scope="col" class="font-weight-bold text-center add-table-data-in-center-width">Code
                </th>
                <th scope="col" class="font-weight-bold text-center add-table-data-in-center-width">Distributed
                  Amount
                </th>
                <th scope="col" class="font-weight-bold text-center">Status
                </th>
                <th scope="col" class="font-weight-bold text-center">Claims
                </th>
                <th scope="col" class="font-weight-bold text-center">History
                </th>
                <th scope="col" class="font-weight-bold text-center">Active
                </th>
                <th scope="col" class="font-weight-bold text-center">Create Date
                </th>
                <th scope="col" class="font-weight-bold text-center">
                  Copy Url
                </th>
              </tr>
            </thead>
            <tbody v-if="data.length > 0">
              <tr v-for="(item, index) in data" :key="item._id">
                <td class="text-center">{{ (currentPage - 1) * pagerow + index + 1 }}</td>
                <td class="text-center" style="min-width:130px;">{{ item.name }}</td>
                <td class="text-center">{{ item.code.toLocaleLowerCase() }}</td>
                <td class="text-center">{{ item.distributed_amount }}</td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button class="btn btn-sm" :class="{
                      'btn-active': item.status == 1,
                      'btn-white': item.status !== 1
                    }" @click="updateStatus(item, 1)">
                      Activate
                    </button>
                    <button class="btn btn-sm" :class="{
                      'btn-active': item.status == 0,
                      'btn-white': item.status !== 0
                    }" @click="updateStatus(item, 0)">
                      Inactivate
                    </button>
                    <button class="btn btn-sm" :class="{
                      'btn-active': item.status == 2,
                      'btn-white': item.status !== 2
                    }" @click="updateStatus(item, 2)">
                      Stop
                    </button>
                  </div>
                </td>
                <td class="text-center">
                  {{ Number(item.claim_count || 0) }} /
                  {{ Number(item.max_claims || 1) }}
                </td>
                <td class="text-center">
                  <button
                    class="btn-copy-envelope pl-2 pr-2"
                    @click="openClaimHistory(item)"
                  >
                    History
                  </button>
                </td>
                <td class="text-center">
                  <button class="btn-copy-envelope pl-2 pr-2" @click="onEdit(item?._id)">
                    Edit</button>
                </td>
                <td class="text-center">{{ new Date(item.created_at).toLocaleDateString() }}</td>
                <td class="text-center">
                  <ol>
                    <p class="remove_margin-block_start" style="color: rgb(255, 168, 46) !important;"
                      v-if="item.status == '0' || item.status == '2'">Timeout
                    </p>
                    <button v-if="item.status == '1'" class="btn-copy-envelope" @click="onCopy(item?.code)">Copy
                      Url</button>
                  </ol>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="10" class="text-center">No Data Found</td>
              </tr>
            </tbody>
          </table>
        </div>
        <nav aria-label="Page navigation" style="display: flex; justify-content:space-between; align-items:center;">
          <div>Showing 1 to {{ pagerow }} of {{ totalCount }}
            Entries
          </div>
          <div>
            <ul class="periodhistory-pagination pagination">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button class="page-link" @click="prevPage">Previous</button>
              </li>
              <li class="page-item">
                <button class="page-link" @click="gotoPage(currentPage - 1)" v-if="currentPage > 1">
                  {{ currentPage - 1 }}
                </button>
              </li>
              <li class="page-item active" v-if="currentPage === 1 || currentPage !== totalPages">
                <button class="page-link" @click="gotoPage(currentPage)">
                  {{ currentPage }}
                </button>
              </li>
              <li class="page-item">
                <button class="page-link" @click="gotoPage(currentPage + 1)" v-if="
                  currentPage < totalPages && currentPage + 1 !== totalPages
                ">
                  {{ currentPage + 1 }}
                </button>
              </li>
              <li class="page-item">
                <button class="page-link" v-if="totalPages > 2">....</button>
              </li>
              <li class="page-item" :class="currentPage === totalPages && 'active'">
                <button class="page-link" @click="gotoPage(totalPages)" v-if="totalPages > 1">
                  {{ totalPages }}
                </button>
              </li>
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <button class="page-link" @click="nextPage">Next</button>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>

  </div>
  <div class="toast-content" v-show="isErrorShow" style="position: fixed;top: 0px;bottom: 0px;left: 0px;right: 0px;">
    <div class="toast-message">{{ errorMessage }}</div>
  </div>
  <!-- Claim History Modal -->
  <div v-if="claimHistoryVisible" class="red-envelope-history-overlay">
    <div class="red-envelope-history-modal">

      <div class="red-envelope-history-header">
        <div>
          <h4>Red Envelope Claim History</h4>
          <div v-if="selectedEnvelope">
            {{ selectedEnvelope.name }} |
            {{ selectedEnvelope.code }}
          </div>
        </div>

        <button
          type="button"
          class="red-envelope-history-close"
          @click="closeClaimHistory"
        >
          ×
        </button>
      </div>

      <div class="red-envelope-history-summary">
        Total Claims: {{ claimHistoryTotal }}
      </div>

      <div v-if="claimHistoryLoader" class="text-center p-3">
        Loading history...
      </div>

      <div v-else class="table-responsive">
        <table class="periodhistory-table table">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-center">Mobile</th>
              <th class="text-center">Amount</th>
              <th class="text-center">Claim Time</th>
              <th class="text-center">Status</th>
            </tr>
          </thead>

          <tbody v-if="claimHistory.length > 0">
            <tr
              v-for="(claim, index) in claimHistory"
              :key="claim._id"
            >
              <td class="text-center">
                {{ (claimHistoryPage - 1) * claimHistoryPageRow + index + 1 }}
              </td>

              <td class="text-center">
                {{ claim.mobile || "-" }}
              </td>

              <td class="text-center">
                ₹{{ claim.amount }}
              </td>

              <td class="text-center">
                {{ formatClaimTime(claim.claimed_at) }}
              </td>

              <td class="text-center">
                {{ claim.status || "-" }}
              </td>
            </tr>
          </tbody>

          <tbody v-else>
            <tr>
              <td colspan="5" class="text-center">
                No claims found
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="red-envelope-history-footer">
        <button
          class="btn-copy-envelope"
          :disabled="claimHistoryPage <= 1"
          @click="previousClaimHistoryPage"
        >
          Previous
        </button>

        <span>
          Page {{ claimHistoryPage }}
          of {{ claimHistoryTotalPages || 1 }}
        </span>

        <button
          class="btn-copy-envelope"
          :disabled="claimHistoryPage >= claimHistoryTotalPages"
          @click="nextClaimHistoryPage"
        >
          Next
        </button>
      </div>

    </div>
  </div>

  <!-- loader -->
  <div class="loadings" v-show="loader">
    <AdminLoader />
  </div>
</template>

<script>
import axios from "axios";
import Navbar from "./Navbar.vue";
import SaidManuBar from "./SideMenuBar.vue";
import AdminLoader from "./AdminLoaders.vue";
export default {
  name: "AdminAccepWithdrawal",
  data() {
    return {
      data: [],
      currentPage: 1,
      totalPages: 0,
      pagerow: 10,
      searchTerms: "",
      loader: false,
      totalCount: 0,
      errorMessage: '',
      isErrorShow: false,
      claimHistoryVisible: false,
      claimHistoryLoader: false,
      selectedEnvelope: null,
      claimHistory: [],
      claimHistoryPage: 1,
      claimHistoryPageRow: 10,
      claimHistoryTotal: 0,
      claimHistoryTotalPages: 0
    };
  },
  components: {
    Navbar,
    SaidManuBar,
    AdminLoader
  },
  methods: {
    async addRedEnvelop() {
      this.$router.push({ name: "AdminAddRedEnvelope" });
    },
    async onEdit(id) {
      this.$router.push({ name: "adminEditRedEnvelope", params: { id } });
    },
    async getPeriodIdData() {
      this.loader = true;
      try {
        const response = await axios.get("/admin/red-envelope-data-list", {
          params: {
            page: this.currentPage,
            pageRow: this.pagerow,
            search: this.searchTerms,
          },
        });
        if (response.data.success) {
          this.data = response.data.data;
          this.totalPages = response.data.totalPages;
          this.totalCount = response.data.total;
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loader = false;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getPeriodIdData();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getPeriodIdData();
      }
    },
    gotoPage(page) {
      this.currentPage = page;
      this.getPeriodIdData();
    },
    search() {
      this.currentPage = 1;
      this.getPeriodIdData();
    },
    async openClaimHistory(item) {
      this.selectedEnvelope = item;
      this.claimHistoryVisible = true;
      this.claimHistoryPage = 1;
      await this.getClaimHistory();
    },

    closeClaimHistory() {
      this.claimHistoryVisible = false;
      this.selectedEnvelope = null;
      this.claimHistory = [];
      this.claimHistoryTotal = 0;
      this.claimHistoryTotalPages = 0;
    },

    async getClaimHistory() {
      if (!this.selectedEnvelope?._id) {
        return;
      }

      this.claimHistoryLoader = true;

      try {
        const response = await axios.get(
          "/admin/red-envelope-claim-history",
          {
            params: {
              envelopeId: this.selectedEnvelope._id,
              page: this.claimHistoryPage,
              pageRow: this.claimHistoryPageRow
            }
          }
        );

        if (response.data.success) {
          this.claimHistory = response.data.data || [];
          this.claimHistoryTotal = response.data.total || 0;
          this.claimHistoryTotalPages = response.data.totalPages || 0;
        }
      } catch (error) {
        console.error("Error fetching claim history:", error);
        this.setErrorMessage("Failed to load claim history");
      } finally {
        this.claimHistoryLoader = false;
      }
    },

    previousClaimHistoryPage() {
      if (this.claimHistoryPage > 1) {
        this.claimHistoryPage--;
        this.getClaimHistory();
      }
    },

    nextClaimHistoryPage() {
      if (this.claimHistoryPage < this.claimHistoryTotalPages) {
        this.claimHistoryPage++;
        this.getClaimHistory();
      }
    },

    formatClaimTime(value) {
      if (!value) {
        return "-";
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return "-";
      }

      return date.toLocaleString();
    },

    async updateStatus(item, status) {
      try {
        const response = await axios.put('/admin/red-envelope-status-update', null, {
          params: {
            id: item._id,
            status: status
          }
        });

        if (response.data.success) {
          item.status = status;
          this.setErrorMessage("Status updated successfully");
        }
      } catch (error) {
        console.error("Error updating status", error);
        this.setErrorMessage("Failed to update status");
      }
    },
    setErrorMessage(value) {
      this.errorMessage = value;
      this.isErrorShow = true;
      setTimeout(() => {
        this.errorMessage = "";
        this.isErrorShow = false;
      }, 2000);
    },
    async onCopy(value) {
      try {
        console.log("onCopy", value)
        var curl = 'http://' + location.host + '/#/redenvelopes?code=' + value;

        await navigator.clipboard.writeText(curl)
        this.setErrorMessage("Success");
      } catch ($e) {
        this.setErrorMessage("Cannot copy");
      }
    },
  },
  mounted() {
    this.getPeriodIdData();
  },
};
</script>

<style>

.red-envelope-history-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.red-envelope-history-modal {
  width: min(950px, 95vw);
  max-height: 90vh;
  overflow-y: auto;
  background: #111;
  border: 1px solid #444;
  border-radius: 6px;
  padding: 16px;
}

.red-envelope-history-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.red-envelope-history-header h4 {
  margin: 0 0 5px;
  color: #fff;
}

.red-envelope-history-header div {
  color: #bbb;
}

.red-envelope-history-close {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.red-envelope-history-summary {
  color: #fff;
  padding: 8px 0;
}

.red-envelope-history-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
}

.btn-envelop {
  color: #fff;
  font-size: 12px;
  background-color: #318dbc;
  padding: 0px;
  width: 100%;
}

.btn-copy-envelope {
  color: #fff;
  font-size: 12px;
  background-color: #318dbc;
  padding-bottom: 10px;
  padding-top: 10px;
  border: none;
}

.btn-envelop:hover {
  color: #fff;
}

.btn-active {
  background-color: #dd4b39;
  color: white;
}

.btn-white {
  background-color: white;
  color: black;
  border: 1px solid #ccc;
}

.btn {
  border: none;
}

.btn:hover {
  opacity: 0.8;
}
</style>